module.exports = __webpack_public_path__ + "static/media/app_logo.c87a5681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_logo.png
// module id = 515
// module chunks = 0